import service from '../service'
// import qs from 'qs'
// import axios from 'axios'
import Store from '@/store'
function getStorage (name) {
  return sessionStorage.getItem(name)
}

function setStorage (name, value) {
  sessionStorage.setItem(name, value)
}

console.log('Store', Store)

function submitccLog(logEntry, type, data) {
  // 神策曝光数据提交
  const ccUsersInfo = service.state
  data.data_from = '生活+H5'
  data.user_type = Store.getters.isFormalEmp
  if (ccUsersInfo && ccUsersInfo.user) {
    data.userId = ccUsersInfo.user.ccOpenId
    data.user_openid = ccUsersInfo.user.wxOpenId
    data.user_name = ccUsersInfo.user.nickName
    data = Object.assign(data, ccUsersInfo)
  }
  let partnerType = logEntry.includes('_click') ? 'PartnerPageClick' : 'PartnerPageShow'
  let params = {
    ...data,
    price: data.original_price,
    number: data.product_quantity,
    album_data_from: 'H5',
    user_improve_value: data.user_empNo,
    // 神策改为total
    total: data.total_number_of_commodity ? String(data.total_number_of_commodity) : ''
  }
  // 神策没有的字段不能提交
  delete params.inited
  delete params.data_from
  delete params.user_empNo
  delete params.user
  delete params.product_quantity
  delete params.original_price
  delete params.total_number_of_commodity
  // 提交到神策
  sensors.track(partnerType, params)
  // let objDate = {
  //   name: logEntry,
  //   logid: 'partner_mini_' + +new Date(),
  //   uid: '',
  //   did: '24186028',
  //   mac: '2835456A57F6',
  //   sid: '',
  //   action: type,
  //   time: +new Date(),
  //   device: {
  //     brand: '',
  //     model: 'Q5A',
  //     chip: '8N01',
  //     os: 0,
  //     os_vername: '',
  //     vercode: '',
  //     barcode: ''
  //   },
  //   pkg: {
  //     productID: 'CC_product_Server',
  //     pkg_name: '',
  //     chip: '8N01',
  //     pkg_vername: 0,
  //     pkg_vercode: '',
  //     pkg_source: ''
  //   },
  //   data: data
  // }
  // let stringData = JSON.stringify(objDate)
  // axios({
  //   method: 'post',
  //   // 生产环境用get
  //   url: 'https://wlog.skysrt.com/dataCollect/push?params=' + encodeURIComponent(stringData)
  //   // 测试环境用post
  //   // url: 'http://1.117.39.22/submit_cc_log',
  //   // data:objDate
  // })
}

/**
 * 将 url 参数 解析为 js 对象
 * */
function $getUrlParams(url) {
  const search = url.substring(url.indexOf('?') + 1) || location.search.substr(1) // 去掉 ？
  // 从 & 符号开始分割为数组
  const obj = {}
  search.split('&').forEach((item) => {
    const res = item.split('=')
    obj[res[0]] = res[1]
  })
  return obj
}

export default {
  getStorage,
  setStorage,
  submitccLog,
  $getUrlParams
}
